import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { SectionHeading } from './ui/SectionHeading';
import { FadeIn } from './ui/FadeIn';
export function FAQ() {
  const faqs = [{
    q: '¿Necesito saber mecánica para usar el pack?',
    a: 'Para nada. Está diseñado para personas sin conocimientos mecánicos. Todo en lenguaje simple, con checklists y guías paso a paso.'
  }, {
    q: '¿Me sirve si mi auto es viejo?',
    a: 'Sí, especialmente. Los autos usados son los más afectados por presupuestos inflados. Aplica a cualquier marca y modelo.'
  }, {
    q: '¿Sirve para motos de baja cilindrada?',
    a: 'Sí. Service Pro es ideal para motos de uso diario, incluyendo baja cilindrada. Los mantenimientos básicos aplican a casi cualquier moto.'
  }, {
    q: '¿Esto reemplaza a un mecánico de confianza?',
    a: 'No. Te ayuda a ir con más información para tomar mejores decisiones: qué preguntar, qué revisar y cuándo pedir segunda opinión.'
  }, {
    q: '¿Cómo recibo el pack después de comprar?',
    a: 'Al completar la compra recibís acceso inmediato. Lo abrís desde celular, computadora o tablet al instante.'
  }, {
    q: '¿Puedo realmente ahorrar dinero con esto?',
    a: 'Con evitar una sola reparación innecesaria ya recuperás la inversión. Un service mal cobrado puede costarte mucho más que $19.999.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleOpen = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section id="faq" className="bg-mc-dark2 py-[72px] px-5" data-id="element-60">
      <div className="max-w-[1100px] mx-auto text-center" data-id="element-61">
        <FadeIn data-id="element-62">
          <SectionHeading centered data-id="element-63">Preguntas frecuentes</SectionHeading>
        </FadeIn>

        <div className="max-w-[760px] mx-auto mt-9 flex flex-col gap-2.5" data-id="element-64">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <FadeIn key={index} delay={index * 0.1} data-id="element-65">
                <div className="bg-mc-gray rounded-lg border border-mc-gray3 overflow-hidden text-left" data-id="element-66">
                  <button onClick={() => toggleOpen(index)} className="w-full bg-transparent border-none text-white font-body text-base font-bold py-4 px-5 text-left cursor-pointer flex justify-between items-center gap-3 transition-colors hover:bg-mc-gray2" data-id="element-67">
                    {faq.q}
                    <motion.span animate={{
                  rotate: isOpen ? 180 : 0
                }} transition={{
                  duration: 0.2
                }} className="shrink-0 text-[0.9rem] text-mc-yellow" data-id="element-68">
                      ▼
                    </motion.span>
                  </button>
                  <AnimatePresence initial={false} data-id="element-69">
                    {isOpen && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.3,
                  ease: 'easeInOut'
                }} data-id="element-70">
                        <div className="px-5 pb-4 text-mc-text text-[0.95rem] leading-[1.7]" data-id="element-71">
                          {faq.a}
                        </div>
                      </motion.div>}
                  </AnimatePresence>
                </div>
              </FadeIn>;
        })}
        </div>
      </div>
    </section>;
}